var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72963 9.37965C4.62253 9.48738 4.47642 9.54748 4.32464 9.54748C4.17287 9.54748 4.02675 9.48738 3.91966 9.37965L0.685333 6.1448C0.349681 5.80915 0.349681 5.26487 0.685333 4.92985L1.09032 4.52476C1.42608 4.1891 1.96973 4.1891 2.30538 4.52476L4.32464 6.54412L9.78099 1.08768C10.1167 0.752024 10.6609 0.752024 10.996 1.08768L11.401 1.49277C11.7367 1.82842 11.7367 2.3726 11.401 2.70772L4.72963 9.37965Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCheck);
export default __webpack_public_path__ + "static/media/active-check.6ba7307ae508fd0ed3ede47abf0a23f3.svg";
export { ForwardRef as ReactComponent };